export enum Experiment {
  EnablePublicAppData = 'specs.membersArea.enableAppData',
  EnableNotifications = 'specs.membersArea.enableNotificationsOnV2',
  UseNotificationsV2Api = 'specs.ping.membersAreaUseNotificationsV2Api',
  HideNotificationsCounterInDropdownAndMemberMenus = 'specs.ping.membersArea.hideNotificationsCounterInDropdownAndMemberMenus',
  AddNavigationIntentParams = 'specs.membersArea.addNavigationIntentParams',
}
